import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AbandonedCart = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        fill="none"
        viewBox="0 0 32 32"
        ref={forwardedRef}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.43579 20.6411L5.06079 11.2661H26.0608L23.6233 20.6411H7.43579Z" fill="#F655DD" />
        <mask id="path-2-inside-1_7094_451" fill="white">
          <rect
            x="3.56421"
            y="8.25671"
            width="11.0532"
            height="11.0532"
            rx="1"
            transform="rotate(-15 3.56421 8.25671)"
          />
        </mask>
        <rect
          x="3.56421"
          y="8.25671"
          width="11.0532"
          height="11.0532"
          rx="1"
          transform="rotate(-15 3.56421 8.25671)"
          fill="#F8B200"
          stroke="#2B2F38"
          strokeWidth="2.8"
          mask="url(#path-2-inside-1_7094_451)"
        />
        <path
          d="M13.7 8.30481C13.7 8.1133 13.877 7.97082 14.0641 8.01173L25.738 10.5645C25.9017 10.6004 26.0043 10.7633 25.9659 10.9265L23.8647 19.8383C23.8267 19.9994 23.6653 20.0994 23.5041 20.0615L13.9314 17.8123C13.7958 17.7804 13.7 17.6595 13.7 17.5202L13.7 8.30481Z"
          fill="#FB6434"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <mask id="path-4-inside-2_7094_451" fill="white">
          <rect
            x="8.17993"
            y="22.5443"
            width="5.44143"
            height="4.39632"
            rx="1"
            transform="rotate(0.697674 8.17993 22.5443)"
          />
        </mask>
        <rect
          x="8.17993"
          y="22.5443"
          width="5.44143"
          height="4.39632"
          rx="1"
          transform="rotate(0.697674 8.17993 22.5443)"
          fill="#99E538"
          stroke="#2B2F38"
          strokeWidth="2.8"
          mask="url(#path-4-inside-2_7094_451)"
        />
        <path
          d="M14.0396 3.45264C14.4245 2.78597 15.3868 2.78597 15.7717 3.45264L19.3916 9.72253C19.7765 10.3892 19.2954 11.2225 18.5256 11.2225H11.2857C10.5159 11.2225 10.0348 10.3892 10.4197 9.72253L14.0396 3.45264Z"
          fill="#D9D9D9"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <mask id="path-6-inside-3_7094_451" fill="white">
          <rect x="12.1" y="22.5762" width="12.363" height="4.36448" rx="1" transform="rotate(0.697674 12.1 22.5762)" />
        </mask>
        <rect
          x="12.1"
          y="22.5762"
          width="12.363"
          height="4.36448"
          rx="1"
          transform="rotate(0.697674 12.1 22.5762)"
          fill="#F8B200"
          stroke="#2B2F38"
          strokeWidth="2.8"
          mask="url(#path-6-inside-3_7094_451)"
        />
        <rect
          x="19.7588"
          y="4.39731"
          width="8.95022"
          height="8.95022"
          rx="4.47511"
          transform="rotate(27.4627 19.7588 4.39731)"
          fill="#BEE9FC"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M7.43579 20.6411L5.06079 11.2661H26.0608L23.6233 20.6411H7.43579Z"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.3733 20.6411L24.6858 26.3911H7.43579"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="9.77954" cy="27.8911" r="1.45625" fill="white" stroke="#2B2F38" strokeWidth="1.4" />
        <circle cx="21.967" cy="27.8911" r="1.45625" fill="white" stroke="#2B2F38" strokeWidth="1.4" />
        <path
          d="M9.77954 11.4536V14.4536V20.2661"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6337 11.4536V14.4536V20.2661"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4879 11.4536V14.4536V20.2661"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.342 11.4536V14.4536V20.2661"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.1233 11.125L27.5608 5.9375H29.4375"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default AbandonedCart
